/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    strong: "strong",
    a: "a",
    h3: "h3",
    h4: "h4",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    ul: "ul",
    li: "li",
    ol: "ol",
    em: "em"
  }, _provideComponents(), props.components), {Specialization, BuildLink, Skill, Trait, Boon, Divider, CharacterWithAr, Character, Item, Grid, GridItem, Traits, Control, Condition, Warning, Effect, Video, Card} = _components;
  if (!Boon) _missingMdxReference("Boon", true);
  if (!BuildLink) _missingMdxReference("BuildLink", true);
  if (!Card) _missingMdxReference("Card", true);
  if (!Character) _missingMdxReference("Character", true);
  if (!CharacterWithAr) _missingMdxReference("CharacterWithAr", true);
  if (!Condition) _missingMdxReference("Condition", true);
  if (!Control) _missingMdxReference("Control", true);
  if (!Divider) _missingMdxReference("Divider", true);
  if (!Effect) _missingMdxReference("Effect", true);
  if (!Grid) _missingMdxReference("Grid", true);
  if (!GridItem) _missingMdxReference("GridItem", true);
  if (!Item) _missingMdxReference("Item", true);
  if (!Skill) _missingMdxReference("Skill", true);
  if (!Specialization) _missingMdxReference("Specialization", true);
  if (!Trait) _missingMdxReference("Trait", true);
  if (!Traits) _missingMdxReference("Traits", true);
  if (!Video) _missingMdxReference("Video", true);
  if (!Warning) _missingMdxReference("Warning", true);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "The ", React.createElement(_components.strong, null, React.createElement(Specialization, {
    text: "Condi Weaver",
    name: "Weaver"
  })), " is an unique build that can be played very effectively in ", React.createElement(_components.a, {
    href: "/fractals/sunqua-peak"
  }, "Sunqua Peak"), " and Silent Surf CMs (this build can also be an attractive choice for other CM and T4 encounters with longer phases, like Ensolyss, if you find yourself in a slow group)."), "\n", React.createElement(_components.p, null, "Condi ", React.createElement(Specialization, {
    name: "Weaver"
  }), " can deal very high amounts of damage, and even rival strong builds like ", React.createElement(BuildLink, {
    build: "Condi Holosmith",
    specialization: "Holosmith"
  }), " and ", React.createElement(BuildLink, {
    build: "Condi Specter",
    specialization: "Specter"
  }), " when played properly."), "\n", React.createElement(_components.p, null, "This build is naturally tanky due to its rotation, having above 90% uptime on the ", React.createElement(Skill, {
    name: "Rocky Loop",
    id: "62975"
  }), " buff. On top of that damage reduction, it has permanent 10% DR from ", React.createElement(Trait, {
    name: "Geomancer's Training",
    id: "280"
  }), " and 7% DR on ~ 40% uptime from ", React.createElement(Trait, {
    name: "Stone Flesh",
    id: "278"
  }), "."), "\n", React.createElement(_components.p, null, "The main downside of ", React.createElement(_components.strong, null, React.createElement(Specialization, {
    text: "Condi Weaver",
    name: "Weaver"
  })), " apart from the complexity of its rotation is the lack of unique party buffs and overall boon generation, apart from some ", React.createElement(Boon, {
    name: "Might"
  }), " generated by ", React.createElement(Skill, {
    id: "25486",
    id: "25486"
  }), "."), "\n", React.createElement(Divider, {
    text: "Equipment"
  }), "\n", React.createElement(CharacterWithAr, null, React.createElement(Character, {
    title: "Condi Weaver",
    gear: "{\"attributes\":{\"profession\":\"Elementalist\",\"specialization\":\"Weaver\",\"data\":{\"Health\":16245,\"Armor\":2192,\"Power\":3124.41,\"Precision\":1987,\"Toughness\":1225,\"Vitality\":1533,\"Ferocity\":9,\"Condition Damage\":2817,\"Expertise\":676,\"Concentration\":225,\"Healing Power\":0,\"Agony Resistance\":150,\"Condition Duration\":0.8006666666666666,\"Boon Duration\":0.15,\"Critical Chance\":0.9199999999999999,\"Critical Damage\":1.506,\"Power Coefficient\":2166,\"Power2 Coefficient\":0,\"Burning Coefficient\":12.584000000000001,\"Bleeding Coefficient\":16.8,\"Poison Coefficient\":0,\"Torment Coefficient\":3.046,\"Confusion Coefficient\":0,\"Flat DPS\":0,\"Burning Duration\":0.2,\"Bleeding Duration\":0.2,\"Siphon Base Coefficient\":139.75,\"Effective Power\":8839.56509297349,\"NonCrit Effective Power\":6031.69188613836,\"Power DPS\":7372.544471074539,\"Power2 DPS\":0,\"Siphon DPS\":139.75,\"Bleeding Damage Tick\":325.90877299999994,\"Bleeding Stacks\":33.6,\"Bleeding DPS\":10950.534772799998,\"Burning Damage Tick\":968.4704552499999,\"Burning Stacks\":25.168000000000003,\"Burning DPS\":24374.464417732,\"Confusion Damage Tick\":345.08078054999993,\"Confusion Stacks\":0,\"Confusion DPS\":0,\"Poison Damage Tick\":345.52949799999993,\"Poison Stacks\":0,\"Poison DPS\":0,\"Torment Damage Tick\":486.8157794999999,\"Torment Stacks\":5.484830666666666,\"Torment DPS\":2670.1021164188373,\"Damage\":45507.39577802537,\"Effective Health\":78737512.43781096,\"Survivability\":40029.23865674172,\"Effective Healing\":390,\"Healing\":390}},\"armor\":{\"weight\":\"Light\",\"helmAffix\":\"Viper\",\"helmRuneId\":67339,\"helmRune\":\"Trapper\",\"helmRuneCount\":6,\"helmInfusionId\":37130,\"shouldersAffix\":\"Viper\",\"shouldersRuneId\":67339,\"shouldersRune\":\"Trapper\",\"shouldersRuneCount\":6,\"shouldersInfusionId\":37130,\"coatAffix\":\"Viper\",\"coatRuneId\":67339,\"coatRune\":\"Trapper\",\"coatRuneCount\":6,\"coatInfusionId\":37130,\"glovesAffix\":\"Viper\",\"glovesRuneId\":67339,\"glovesRune\":\"Trapper\",\"glovesRuneCount\":6,\"glovesInfusionId\":37130,\"leggingsAffix\":\"Viper\",\"leggingsRuneId\":67339,\"leggingsRune\":\"Trapper\",\"leggingsRuneCount\":6,\"leggingsInfusionId\":37130,\"bootsAffix\":\"Viper\",\"bootsRuneId\":67339,\"bootsRune\":\"Trapper\",\"bootsRuneCount\":6,\"bootsInfusionId\":37130},\"weapon\":{\"weapon1MainId\":30690,\"weapon1MainType\":\"Hammer\",\"weapon1MainSigil1Id\":24560,\"weapon1MainAffix\":\"Viper\",\"weapon1MainInfusion1Id\":37130,\"weapon1MainInfusion2Id\":37130,\"weapon1MainSigil2Id\":48911,\"weapon2MainInfusion2Id\":37130,\"weapon2MainSigil2Id\":48911},\"backAndTrinket\":{\"backItemAffix\":\"Sinister\",\"backItemInfusion1Id\":37130,\"backItemInfusion2Id\":37130,\"amuletAffix\":\"Viper\",\"ring1Affix\":\"Viper\",\"ring1Infusion1Id\":37130,\"ring1Infusion2Id\":37130,\"ring1Infusion3Id\":37130,\"ring2Affix\":\"Viper\",\"ring2Infusion1Id\":37130,\"ring2Infusion2Id\":37130,\"ring2Infusion3Id\":37130,\"accessory1Affix\":\"Viper\",\"accessory1InfusionId\":37130,\"accessory2Affix\":\"Viper\",\"accessory2InfusionId\":37130},\"consumables\":{\"foodId\":91878,\"utilityId\":48917,\"relicId\":100153},\"skills\":{\"healId\":5503,\"utility1Id\":5506,\"utility2Id\":40183,\"utility3Id\":5542,\"eliteId\":43638},\"assumedBuffs\":{\"value\":[{\"id\":\"might\",\"type\":\"Boon\"},{\"id\":\"fury\",\"type\":\"Boon\"},{\"id\":\"protection\",\"type\":\"Boon\"},{\"id\":\"vulnerability\",\"type\":\"Condition\"},{\"id\":\"reinforced-armor\",\"type\":\"Text\"},{\"id\":\"jade-bot\",\"gw2id\":96613,\"type\":\"Item\"},{\"id\":\"omnipotion\",\"gw2id\":79722,\"type\":\"Item\"}]},\"traits\":{\"selection\":[[296,325,1510],[1507,275,287],[2177,2180,2131]],\"lines\":[31,26,56]}}"
  }, React.createElement(_components.p, null, "This build uses the Jade Bot Core: Tier 10 in combination with 18 ", React.createElement(Item, {
    name: "Malign +9 Agony Infusion",
    id: "37130"
  }), "."))), "\n", React.createElement(Divider, {
    text: "Build"
  }), "\n", React.createElement(Grid, null, React.createElement(GridItem, {
    sm: "7"
  }, React.createElement(_components.h3, null, "Traits"), React.createElement(Traits, {
    traits1: "Fire",
    traits1Selected: "Burning Precision, Burning Rage, Persisting Flames",
    traits2: "Earth",
    traits2Selected: "Serrated Stones, Strength of Stone, Written in Stone",
    traits3: "Weaver",
    traits3Selected: "Superior Elements, Weavers Prowess, Elements of Rage",
    traits1Id: "31",
    traits1SelectedIds: "296,325,1510",
    traits2Id: "26",
    traits2SelectedIds: "1507,275,287",
    traits3Id: "56",
    traits3SelectedIds: "2177,2180,2131"
  }), React.createElement(_components.h4, null, "Situational Traits"), React.createElement(_components.table, null, React.createElement(_components.thead, null, React.createElement(_components.tr, null, React.createElement(_components.th), React.createElement(_components.th))), React.createElement(_components.tbody, null, React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Trait, {
    name: "Pyromancers Puissance",
    size: "big",
    disableText: true,
    id: "294"
  })), React.createElement(_components.td, null, "Can easily cover a large amount of ", React.createElement(Boon, {
    name: "Might"
  }), " for your group at a minor personal DPS loss. This build can't generate any ", React.createElement(Trait, {
    name: "Persisting Flames",
    id: "1510"
  }), " stacks so the dps loss comes only from the time you need until your own might ramps up.")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Trait, {
    name: "Masters Fortitude",
    size: "big",
    disableText: true,
    id: "2115"
  })), React.createElement(_components.td, null, "Provides a bit of tankiness in the form of extra vitality for minimal DPS loss.")))), React.createElement(_components.h3, null, "Defiance Bar Damage"), React.createElement(_components.h4, null, "Hammer"), React.createElement(_components.table, null, React.createElement(_components.thead, null, React.createElement(_components.tr, null, React.createElement(_components.th, null, "Skill"), React.createElement(_components.th, null, "Damage"))), React.createElement(_components.tbody, null, React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(_components.strong, null, "Hammer")), React.createElement(_components.td)), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Shock Blast",
    size: "big",
    disableText: true,
    id: "62716"
  })), React.createElement(_components.td, null, "150 with ", React.createElement(Control, {
    name: "Stun"
  }))), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Wind Storm",
    size: "big",
    disableText: true,
    id: "62947"
  })), React.createElement(_components.td, null, "200 with ", React.createElement(Control, {
    name: "Knockdown"
  }))), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Ground Pound",
    size: "big",
    disableText: true,
    id: "62778"
  })), React.createElement(_components.td, null, "50/s with ", React.createElement(Condition, {
    name: "Immobile"
  }))), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Rain of Blows",
    size: "big",
    disableText: true,
    id: "62958"
  })), React.createElement(_components.td, null, "33/s with ", React.createElement(Condition, {
    name: "Chilled"
  }))), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Tailored Victory",
    size: "big",
    disableText: true,
    id: "44637"
  })), React.createElement(_components.td, null, "250 with ", React.createElement(Control, {
    name: "Float"
  }))), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(_components.strong, null, "Scepter")), React.createElement(_components.td)), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Earthen Synergy",
    size: "big",
    disableText: true,
    id: "40794"
  })), React.createElement(_components.td, null, "150 with ", React.createElement(Control, {
    name: "Stun"
  }))), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Fiery Frost",
    size: "big",
    disableText: true,
    id: "42181"
  })), React.createElement(_components.td, null, "33/s  with ", React.createElement(Condition, {
    name: "Chilled"
  }))), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Glacial Drift",
    size: "big",
    disableText: true,
    id: "45742"
  })), React.createElement(_components.td, null, "33/s  with ", React.createElement(Condition, {
    name: "Chilled"
  }))), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(_components.strong, null, "Warhorn")), React.createElement(_components.td)), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Cyclone",
    size: "big",
    disableText: true,
    id: "30008"
  })), React.createElement(_components.td, null, "150 with ", React.createElement(Control, {
    name: "Pull"
  }))), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Tidal Surge",
    size: "big",
    disableText: true,
    id: "30864"
  })), React.createElement(_components.td, null, "150 with ", React.createElement(Control, {
    name: "Knockback"
  }))), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Dust Storm",
    size: "big",
    disableText: true,
    id: "30336"
  })), React.createElement(_components.td, null, "20/s with ", React.createElement(Condition, {
    name: "Blinded"
  }))), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(_components.strong, null, "Focus")), React.createElement(_components.td)), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Gale",
    size: "big",
    disableText: true,
    id: "5562"
  })), React.createElement(_components.td, null, "400 with ", React.createElement(Control, {
    name: "Knockdown"
  }))), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Magnetic Wave",
    size: "big",
    disableText: true,
    id: "5555"
  })), React.createElement(_components.td, null, "15/s with ", React.createElement(Condition, {
    name: "Crippled"
  }))), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Freezing Gust",
    size: "big",
    disableText: true,
    id: "5556"
  })), React.createElement(_components.td, null, "33/s with ", React.createElement(Condition, {
    name: "Chilled"
  }))), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Comet",
    size: "big",
    disableText: true,
    id: "5490"
  })), React.createElement(_components.td, null, "200 with ", React.createElement(Control, {
    name: "Daze"
  }))))), React.createElement(_components.p, null, React.createElement(_components.strong, null, "Many of these skills aren't accessible during the normal rotation due to being locked behind attunements you don't use."))), React.createElement(GridItem, {
    sm: "5"
  }, React.createElement(_components.h3, null, "Situational Skills"), React.createElement(Warning, null, React.createElement(_components.p, null, "If you do want to switch any of your utilites in favor of one of the skills listed below, you should prioritise dropping ", React.createElement(Skill, {
    name: "Glyph of Elemental Power",
    id: "5506"
  }), " before ", React.createElement(Skill, {
    name: "Primordial Stance",
    id: "40183"
  }), " and ", React.createElement(Skill, {
    name: "Signet of fire",
    id: "5542"
  }), ".")), React.createElement(_components.table, null, React.createElement(_components.thead, null, React.createElement(_components.tr, null, React.createElement(_components.th), React.createElement(_components.th))), React.createElement(_components.tbody, null, React.createElement(_components.tr, null, React.createElement(_components.td, null, "Heal"), React.createElement(_components.td)), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Arcane Brilliance",
    size: "big",
    disableText: true,
    id: "21656"
  })), React.createElement(_components.td, null, "An additional ", React.createElement(Boon, {
    name: "Might"
  }), " source from blasting fire fields. Overall provides less healing than ", React.createElement(Skill, {
    name: "Signet Of Restoration",
    id: "5503"
  }), ".")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Glyph of Elemental Harmony",
    size: "big",
    disableText: true,
    id: "5569"
  })), React.createElement(_components.td, null, "A stronger alternative healing skill when you need to restore a large amount of health very quickly.")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Aquatic stance",
    size: "big",
    disableText: true,
    id: "44239"
  })), React.createElement(_components.td, null, "Another alternative healing skill affecting allies close to the target you strike.")), React.createElement(_components.tr, null, React.createElement(_components.td, null, "Offensive"), React.createElement(_components.td)), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Glyph of Lesser Elementals",
    size: "big",
    disableText: true,
    id: "5502"
  })), React.createElement(_components.td, null, "A stronger alternative to ", React.createElement(Skill, {
    name: "Glyph of Elemental Power",
    id: "5506"
  }), " but relies on rng and works better in fights with longer phases.")), React.createElement(_components.tr, null, React.createElement(_components.td, null, "Defensive"), React.createElement(_components.td)), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Arcane Shield",
    size: "big",
    disableText: true,
    id: "5641"
  })), React.createElement(_components.td, null, "A stun break with the addition of 3 blocks.")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Armor of Earth",
    size: "big",
    disableText: true,
    id: "5639"
  })), React.createElement(_components.td, null, "Another stun break that provides extra ", React.createElement(Boon, {
    name: "Protection"
  }), " and ", React.createElement(Boon, {
    name: "Stability"
  }), ".")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Stone Resonance",
    size: "big",
    disableText: true,
    id: "44926"
  })), React.createElement(_components.td, null, "A strong skill providing a lot of barrier and extra ", React.createElement(Boon, {
    name: "Stability"
  }), ".")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Twist of Fate",
    size: "big",
    disableText: true,
    id: "45746"
  })), React.createElement(_components.td, null, "Yet another stun break with the addition of evade frames.")), React.createElement(_components.tr, null, React.createElement(_components.td, null, "Utility"), React.createElement(_components.td)), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Lightning Flash",
    size: "big",
    disableText: true,
    id: "5536"
  })), React.createElement(_components.td, null, "A 900 units teleport for easy repositioning.")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Glyph of Renewal",
    size: "big",
    disableText: true,
    id: "5573"
  })), React.createElement(_components.td, null, "You can sacrifice some DPS for a powerful insta rez, can be very useful during \"Dancing with Demons\" runs.")))), React.createElement(_components.h3, null, "Situational Weapons"), React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(_components.strong, null, "Scepter"), " - A lower dps option that is fully ranged and opens up the offhand slot."), "\n", React.createElement(_components.li, null, React.createElement(_components.strong, null, "Warhorn"), " - Your first choice of off hand, useful if your group struggles with boon uptime due to access to ", React.createElement(Skill, {
    name: "Sand Squall",
    id: "29453"
  }), "."), "\n", React.createElement(_components.li, null, React.createElement(_components.strong, null, "Focus"), " - Less dps than warhorn but offers higher cc and more situtional utility in the form of condi cleanse with ", React.createElement(Skill, {
    name: "Magnetic Wave",
    id: "5555"
  }), " and invulnerability with ", React.createElement(Skill, {
    name: "Obsidian Flesh",
    id: "5521"
  }), "."), "\n"))), "\n", React.createElement(Divider, {
    text: "Rotation / Skill usage"
  }), "\n", React.createElement(Warning, null, React.createElement(_components.p, null, "Golem rotations out of the raid builds are generally suboptimal in fractals due to ", React.createElement(Effect, {
    name: "Exposed"
  }), " and phases being much shorter compared to raids. The raid rotations are optimized for sustained DPS while in fractals a player needs the ability to adapt a rotation to the amount of time a group needs to finish a phase.")), "\n", React.createElement(_components.h3, null, "Important Notes"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(_components.p, null, React.createElement(Skill, {
    name: "Signet of Fire",
    id: "5542"
  }), " is one of your most important DPS skills. Use it off cooldown!"), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(_components.p, null, "Make sure to always use ", React.createElement(Skill, {
    name: "Glyph of ELemental Power",
    id: "5506"
  }), " in ", React.createElement(Skill, {
    name: "Fire Attunement",
    id: "5492"
  }), ". If the boss is about to phase or die, your next best option is to use it in ", React.createElement(Skill, {
    name: "Earth Attunement",
    id: "5495"
  }), ". If you find yourself is any other element, you should use it regardless, as it grants increased strike damage on your next few attacks."), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(_components.p, null, React.createElement(Skill, {
    name: "Primordial Stance",
    id: "40183"
  }), " should be used before attuning to ", React.createElement(Skill, {
    name: "Earth Attunement",
    disableText: true,
    id: "5495"
  }), " ", React.createElement(Skill, {
    name: "Fire Attunement",
    disableText: true,
    id: "5492"
  }), " for maximum damage output. However, if the boss' breakbar is about to be broken or about to phase, you can also use it during ", React.createElement(Skill, {
    name: "Fire Attunement",
    disableText: true,
    id: "5492"
  }), " ", React.createElement(Skill, {
    name: "Earth Attunement",
    disableText: true,
    id: "5495"
  }), " or ", React.createElement(Skill, {
    name: "Fire Attunement",
    disableText: true,
    id: "5492"
  }), " ", React.createElement(Skill, {
    name: "Fire Attunement",
    disableText: true,
    id: "5492"
  }), "."), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(_components.p, null, "Although it is important to follow the weave self rotation as closer as possible, the timing when it comes to completing it, is extremely tight and you might find yourself unable to do it especially if you don't have boons precasted on you and they have to be applied once you get in combat. In that scenario the best adjustment you can do is slightly altering the ending. Instead of doing the ", React.createElement(Skill, {
    name: "Fire Attunement",
    disableText: true,
    id: "5492"
  }), "/", React.createElement(Skill, {
    name: "Fire Attunement",
    disableText: true,
    id: "5492"
  }), " => ", React.createElement(Skill, {
    name: "Earth Attunement",
    disableText: true,
    id: "5495"
  }), "/", React.createElement(Skill, {
    name: "Fire Attunement",
    disableText: true,
    id: "5492"
  }), " => ", React.createElement(Skill, {
    name: "Water Attunement",
    disableText: true,
    id: "5493"
  }), "/", React.createElement(Skill, {
    name: "Earth Attunement",
    disableText: true,
    id: "5495"
  }), " loop, do this one: ", React.createElement(Skill, {
    name: "Fire Attunement",
    disableText: true,
    id: "5492"
  }), "/", React.createElement(Skill, {
    name: "Fire Attunement",
    disableText: true,
    id: "5492"
  }), " => ", React.createElement(Skill, {
    name: "Water Attunement",
    disableText: true,
    id: "5493"
  }), React.createElement(Skill, {
    name: "Fire Attunement",
    disableText: true,
    id: "5492"
  }), ", use ", React.createElement(Skill, {
    name: "Triple Sear",
    id: "62807"
  }), " and activate ", React.createElement(Skill, {
    id: "69184",
    id: "69184"
  }), " there, attune to ", React.createElement(Skill, {
    name: "Earth Attunement",
    disableText: true,
    id: "5495"
  }), "/", React.createElement(Skill, {
    name: "Water Attunement",
    disableText: true,
    id: "5493"
  }), ", use ", React.createElement(Skill, {
    name: "Whirling Stones",
    id: "62976"
  }), ", activate ", React.createElement(Skill, {
    id: "69413",
    id: "69413"
  }), ", move to ", React.createElement(Skill, {
    name: "Fire Attunement",
    disableText: true,
    id: "5492"
  }), "/", React.createElement(Skill, {
    name: "Earth Attunement",
    disableText: true,
    id: "5495"
  }), " and continue with the main loop."), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(_components.p, null, "In the video, a 2nd ", React.createElement(Skill, {
    name: "Weave Self",
    id: "43638"
  }), " rotation is shown, which is the same as the 1st. If the encounter has downtime due to phases in between when the boss can't be damaged and ", React.createElement(Skill, {
    name: "Weave Self",
    id: "43638"
  }), " comes off cd then you can freely attune to air and start from the opener. If it doesn't and you know the boss is going to phase before you need to finish the weave self loop, then you can use ", React.createElement(Skill, {
    name: "Weave Self",
    id: "43638"
  }), " right away the moment it comes off cd in the attunement you are in and only switch between ", React.createElement(Skill, {
    name: "Fire Attunement",
    disableText: true,
    id: "5492"
  }), " and ", React.createElement(Skill, {
    name: "Earth Attunement",
    disableText: true,
    id: "5495"
  }), " without entering ", React.createElement(Skill, {
    name: "Tailored Victory",
    id: "44637"
  }), ". If you get ", React.createElement(Skill, {
    name: "Weave Self",
    id: "43638"
  }), " off cd mid fight and the phase is long enough that you need to complete it then it is recommended to attune to ", React.createElement(Skill, {
    name: "Air Attunement",
    disableText: true,
    id: "5494"
  }), " and start from there because completing weave self otherwise is going to be a lot more awkward."), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(_components.p, null, "Hammer 3 orbs are an important part of your damage not only because of their offensive buff but also because they apply condis each time they hit the enemy (they hit once per second). That is why you want to have both ", React.createElement(Skill, {
    name: "Flame Wheel",
    id: "62758"
  }), " and ", React.createElement(Skill, {
    name: "Rocky Loop",
    id: "62975"
  }), " active for as longer as possible. Keep in mind that these buffs get activated together with ", React.createElement(Skill, {
    id: "69164",
    id: "69164"
  }), " but you can only activate ", React.createElement(Skill, {
    name: "Flame Wheel",
    id: "62758"
  }), " individually because you never double attune ", React.createElement(Skill, {
    name: "Earth Attunement",
    id: "5495"
  }), ". Eventually the cooldown of ", React.createElement(Skill, {
    id: "69164",
    id: "69164"
  }), " starts being less aligned with the rotation which is why you go from throwing ", React.createElement(Skill, {
    name: "Grand Finale",
    id: "62876"
  }), " before leaving ", React.createElement(Skill, {
    name: "Fire Attunement",
    id: "5492"
  }), " to throwing it when you enter ", React.createElement(Skill, {
    name: "Earth Attunement",
    disable: true,
    text: true,
    id: "5495"
  }), "/", React.createElement(Skill, {
    name: "Fire Attunement",
    disable: true,
    text: true,
    id: "5492"
  }), " and then when you leave ", React.createElement(Skill, {
    name: "Earth Attunement",
    disable: true,
    text: true,
    id: "5495"
  }), "/", React.createElement(Skill, {
    name: "Fire Attunement",
    disable: true,
    text: true,
    id: "5492"
  }), ". If needed you can also use ", React.createElement(Skill, {
    name: "Grand Finale",
    id: "62876"
  }), " in ", React.createElement(Skill, {
    name: "Fire Attunement",
    disable: true,
    text: true,
    id: "5492"
  }), "/", React.createElement(Skill, {
    name: "Earth Attunement",
    disable: true,
    text: true,
    id: "5495"
  }), " as long as you know ", React.createElement(Skill, {
    id: "69164",
    id: "69164"
  }), " is going to be ready to activate."), "\n"), "\n"), "\n", React.createElement(Grid, null, React.createElement(GridItem, {
    sm: "6"
  }, React.createElement(_components.h3, null, "Rotation during Weave Self"), React.createElement(Grid, null, React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Air Attunement",
    size: "large",
    disableText: true,
    id: "5494"
  }), React.createElement(Skill, {
    name: "Earth Attunement",
    size: "large",
    disableText: true,
    id: "5495"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Weave Self",
    id: "43638"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Signet of Fire",
    id: "5542"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Ground Pound",
    id: "62778"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    id: "69246",
    id: "69246"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  }), React.createElement(Skill, {
    name: "Air Attunement",
    size: "large",
    disableText: true,
    id: "5494"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Primordial Stance",
    id: "40183"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Surging Flames",
    id: "62884"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Grand Finale",
    id: "62876"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  }), React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Triple Sear",
    id: "62807"
  }), "\n"), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Singeing Strike",
    id: "62925"
  }), " x2"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Earth Attunement",
    size: "large",
    disableText: true,
    id: "5495"
  }), React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Flame Wheel",
    id: "62758"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Whirling Stones",
    id: "62976"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Primordial Stance",
    id: "40183"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  }), React.createElement(Skill, {
    name: "Earth Attunement",
    size: "large",
    disableText: true,
    id: "5495"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Singeing Strike",
    id: "62925"
  }), " x4"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  }), React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Surging Flames",
    id: "62884"
  }), "\n"), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Singeing Strike",
    id: "62925"
  }), " x6"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Signet of Fire",
    id: "5542"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Earth Attunement",
    size: "large",
    disableText: true,
    id: "5495"
  }), React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Whirling Stones",
    id: "62976"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  }), React.createElement(Skill, {
    name: "Earth Attunement",
    size: "large",
    disableText: true,
    id: "5495"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Singeing Strike",
    id: "62925"
  }), " x3"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Surging Flames",
    id: "62884"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    id: "34736",
    id: "34736"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Ground Pound",
    id: "62778"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  }), React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Grand Finale",
    id: "62876"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Singeing Strike",
    id: "62925"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Triple Sear",
    id: "62807"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Singeing Strike",
    id: "62925"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Flame Wheel",
    id: "62758"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Singeing Strike",
    id: "62925"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Earth Attunement",
    size: "large",
    disableText: true,
    id: "5495"
  }), React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Whirling Stones",
    id: "62976"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Water Attunement",
    size: "large",
    disableText: true,
    id: "5493"
  }), React.createElement(Skill, {
    name: "Earth Attunement",
    size: "large",
    disableText: true,
    id: "5495"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    id: "69413",
    id: "69413"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Rain of Blows",
    id: "62958"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Signet of Fire",
    id: "5542"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  }), React.createElement(Skill, {
    name: "Water Attunement",
    size: "large",
    disableText: true,
    id: "5493"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Surging Flames",
    id: "62884"
  }), "\n"), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Singeing Strike",
    id: "62925"
  }), " x6"), "\n"))), React.createElement(_components.h3, null, "Golem Rotation"), React.createElement(Video, {
    youtube: "-ML_bmcdBPo",
    caption: "by Ryan"
  })), React.createElement(GridItem, {
    sm: "6"
  }, React.createElement(Card, {
    title: "Precasting"
  }, React.createElement(_components.h3, null, React.createElement(_components.strong, null, "Precast in non boonstrip fights")), React.createElement(_components.p, null, "If you know you can only get one ", React.createElement(Skill, {
    name: "Weave Self",
    id: "43638"
  }), " during the fight then you can precast it and use the second one later. To do that you have to:"), React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, "Start on ", React.createElement(Skill, {
    name: "Fire Attunement",
    id: "5492"
  }), "/", React.createElement(Skill, {
    name: "Earth Attunement",
    id: "5495"
  }), " and precast ", React.createElement(Skill, {
    name: "Glyph of ELemental Power",
    id: "5506"
  }), ", replace a utility with ", React.createElement(Skill, {
    name: "Arcane Power",
    id: "5635"
  }), " and precast it."), "\n", React.createElement(_components.li, null, "Attune to ", React.createElement(Skill, {
    name: "Earth Attunement",
    id: "5495"
  }), "/", React.createElement(Skill, {
    name: "Fire Attunement",
    id: "5492"
  }), " and precast ", React.createElement(Skill, {
    name: "Weave Self",
    id: "43638"
  }), "."), "\n", React.createElement(_components.li, null, "Switch back your replaced utility."), "\n", React.createElement(_components.li, null, "Take the ", React.createElement(_components.em, null, "Mistlock Singularity"), " and attune to ", React.createElement(Skill, {
    name: "Earth Attunement",
    id: "5495"
  }), "/", React.createElement(Skill, {
    name: "Earth Attunement",
    id: "5495"
  }), " for ", React.createElement(Trait, {
    name: "Elements of Rage",
    id: "2131"
  }), "."), "\n", React.createElement(_components.li, null, "Attune to ", React.createElement(Skill, {
    name: "Air Attunement",
    id: "5494"
  }), "/", React.createElement(Skill, {
    name: "Earth Attunement",
    id: "5495"
  }), " and start the fight."), "\n"), React.createElement(_components.h3, null, React.createElement(_components.strong, null, "Precast in fights with boonstrip")), React.createElement(_components.p, null, "In ", React.createElement(_components.a, {
    href: "/fractals/sunqua-peak"
  }, "Sunqua Peak"), " and Silent Surf CMs boons and some specific buffs get stripped the moment you enter combat so your precast has to be adjusted. Also these fights favor use of ", React.createElement(Skill, {
    name: "Glyph of Lesser Elementals",
    id: "5502"
  }), "."), React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, "Start on ", React.createElement(Skill, {
    name: "Fire Attunement",
    id: "5492"
  }), ", precast ", React.createElement(Skill, {
    name: "Glyph of Lesser Elementals",
    id: "5502"
  }), " replace your other utilities with ", React.createElement(Skill, {
    name: "Glyph of ELemental Power",
    id: "5506"
  }), ", ", React.createElement(Skill, {
    name: "Arcane Power",
    id: "5635"
  }), " and precast them."), "\n", React.createElement(_components.li, null, "Take the ", React.createElement(_components.em, null, "Mistlock Singularity"), " and cast another ", React.createElement(Skill, {
    name: "Glyph of Lesser Elementals",
    id: "5502"
  })), "\n", React.createElement(_components.li, null, "Attune to ", React.createElement(Skill, {
    name: "Earth Attunement",
    id: "5495"
  }), "/", React.createElement(Skill, {
    name: "Fire Attunement",
    id: "5492"
  }), " and switch back to your normal utilities."), "\n", React.createElement(_components.li, null, "Attune to ", React.createElement(Skill, {
    name: "Earth Attunement",
    id: "5495"
  }), "/", React.createElement(Skill, {
    name: "Earth Attunement",
    id: "5495"
  }), " for ", React.createElement(Trait, {
    name: "Elements of Rage",
    id: "2131"
  }), "."), "\n", React.createElement(_components.li, null, "Attune to ", React.createElement(Skill, {
    name: "Air Attunement",
    id: "5494"
  }), "/", React.createElement(Skill, {
    name: "Earth Attunement",
    id: "5495"
  }), " and start the fight."), "\n"), React.createElement(_components.h3, null, React.createElement(_components.strong, null, "Extra Precast for ", React.createElement(_components.a, {
    href: "/fractals/sunqua-peak"
  }, "Sunqua Peak"), " and Silent Surf CMs")), React.createElement(_components.p, null, "If you have an extra set of weapons (or legendary sigils), you can also precast the effects of ", React.createElement(Item, {
    name: "Doom",
    id: "24609"
  }), " and ", React.createElement(Item, {
    name: "Leeching",
    id: "24599"
  }), ". To do that:"), React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, "Switch to the sigils."), "\n", React.createElement(_components.li, null, "For Sunqua Peak fall below the stairs before the boss' arena to get in combat and switch to any attunement."), "\n", React.createElement(_components.li, null, "For Silent Surf let go of the parachute a bit earlier so as you get in combat when you fall down and switch to any attunement."), "\n", React.createElement(_components.li, null, "Once you are out of combat, you can switch the sigils back to ", React.createElement(Item, {
    name: "Earth",
    id: "24560"
  }), " and ", React.createElement(Item, {
    name: "Geomancy",
    id: "24605"
  }), "."), "\n")), React.createElement(_components.h3, null, "Rotation outside of Weave Self"), React.createElement(Grid, null, React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  }), React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Singeing Strike",
    id: "62925"
  }), " until ", React.createElement(Skill, {
    name: "Surging Flames",
    id: "62884"
  }), " is almost off cd"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Grand Finale",
    id: "62876"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Surging Flames",
    id: "62884"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Primordial Stance",
    id: "40183"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Earth Attunement",
    size: "large",
    disableText: true,
    id: "5495"
  }), React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Whirling Stones",
    id: "62976"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    id: "69164",
    id: "69164"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Triple Sear",
    id: "62807"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Stonestrike",
    id: "62683"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Signet of Fire",
    id: "5542"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  }), React.createElement(Skill, {
    name: "Earth Attunement",
    size: "large",
    disableText: true,
    id: "5495"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Ground Pound",
    id: "62778"
  }), "\n"), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Singeing Strike",
    id: "62925"
  }), " x4"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Surging Flames",
    id: "62884"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    id: "34736",
    id: "34736"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  }), React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Singeing Strike",
    id: "62925"
  }), " until ", React.createElement(Skill, {
    name: "Surging Flames",
    id: "62884"
  }), " is off cd"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Primordial Stance",
    id: "40183"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Surging Flames",
    id: "62884"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Earth Attunement",
    size: "large",
    disableText: true,
    id: "5495"
  }), React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Grand Finale",
    id: "62876"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Signet of Fire",
    id: "5542"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Whirling Stones",
    id: "62976"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    id: "69164",
    id: "69164"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Stonestrike",
    id: "62683"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Triple Sear",
    id: "62807"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  }), React.createElement(Skill, {
    name: "Earth Attunement",
    size: "large",
    disableText: true,
    id: "5495"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Singeing Strike",
    id: "62925"
  }), " x4"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Ground Pound",
    id: "62778"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Surging Flames",
    id: "62884"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  }), React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Singeing Strike",
    id: "62925"
  }), " until ", React.createElement(Skill, {
    name: "Surging Flames",
    id: "62884"
  }), " is almost off cd"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Primordial Stance",
    id: "40183"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Signet of Fire",
    id: "5542"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Surging Flames",
    id: "62884"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Earth Attunement",
    size: "large",
    disableText: true,
    id: "5495"
  }), React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Whirling Stones",
    id: "62976"
  }), "\n"), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Stonestrike",
    id: "62683"
  }), " x3"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Grand Finale",
    id: "62876"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Triple Sear",
    id: "62807"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  }), React.createElement(Skill, {
    name: "Earth Attunement",
    size: "large",
    disableText: true,
    id: "5495"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    id: "34736",
    id: "34736"
  }), "\n"), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Singeing Strike",
    id: "62925"
  }), " x3"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    id: "69164",
    id: "69164"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Ground Pound",
    id: "62778"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Surging Flames",
    id: "62884"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  }), React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Singeing Strike",
    id: "62925"
  }), " x2 => ", React.createElement(Skill, {
    name: "Signet of Fire",
    id: "5542"
  }), " => ", React.createElement(Skill, {
    name: "Singeing Strike",
    id: "62925"
  }), " until ", React.createElement(Skill, {
    name: "Surging Flames",
    id: "62884"
  }), " is off cd"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Primordial Stance",
    id: "40183"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Surging Flames",
    id: "62884"
  }), "\n"), "\n")), React.createElement(GridItem, {
    sm: "3"
  }, React.createElement(Skill, {
    name: "Earth Attunement",
    size: "large",
    disableText: true,
    id: "5495"
  }), React.createElement(Skill, {
    name: "Fire Attunement",
    size: "large",
    disableText: true,
    id: "5492"
  })), React.createElement(GridItem, {
    sm: "9"
  }, React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Whirling Stones",
    id: "62976"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Stonestrike",
    id: "62683"
  }), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(Skill, {
    name: "Grand Finale",
    id: "62876"
  }), "\n"), "\n"))))));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
